export default {
    methods: {
        open (url, title) {
            this.sendPostMessage({
                url,
                title,
                action: 'open',
                target: '_blank'
            })
        },
        event (name, payload = {}) {
            this.sendPostMessage({
                action: 'event',
                name,
                payload
            })
        },
        sendPostMessage (data) {
            data.key = 'browser'
            data.frame = location.href
            let message = JSON.stringify(data)
            window.parent.postMessage(message, '*');
        }
    }
}